import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getDashboardConnections(payload) {
  return { type: actionTypes.GET_CONNECTIONS, payload };
}
export function getDashboardConnectionsSuccess(paylaod) {
  // console.log('connection....', paylaod)
  // console.log('post...', posts, params)
  const byId = keyBy(paylaod, (con) => con.postUid);
  // console.log('byid....', byId)
  return { type: actionTypes.GET_CONNECTIONS_SUCCESS, payload: { byId } };
}
export function fetchDashboardNotices(payload) {
  return { type: actionTypes.GET_NOTICES, payload };
}
export function fetchDashboardNoticesSuccess(paylaod) {
  // console.log('connection....', paylaod)
  // console.log('post...', posts, params)
  const byId = keyBy(paylaod, (con) => con.postUid);
  // console.log('byid....', byId)
  return { type: actionTypes.GET_NOTICES_SUCCESS, payload: { byId } };
}
export function getDashboardReadPosts(payload) {
  return { type: actionTypes.GET_READ_POSTS, payload };
}
export function getDashboardReadPostsSuccess(payload) {
  const byId = keyBy(payload, (read) => (read.posts_postUid));
  return { type: actionTypes.GET_READ_POSTS_SUCCESS, payload: { byId } }
}
